import {
  get,
} from '@/utils/request';

const url = 'card-ticket-update-records';

export function index(data) {
  return get({
    url,
    data,
  });
}
